import { RouterModule, Routes } from "@angular/router";
import { CustomModalComponent } from "../shared/custom-modal/custom-modal.component";
import { NgModule } from "@angular/core";
import { WidgetContainerComponent } from "./widget-container.component";

const routes: Routes = [{path:'',component:WidgetContainerComponent}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WidgetContainerRoutingModule { }